import React, { useEffect, useRef, useState } from "react";
import config from '../../config';
import { headers } from "../../token";
import axios from "axios";
import html2pdf from 'html2pdf.js';
import { Link, useSearchParams } from "react-router-dom";
import AddComment from "./AddComment";
import ModifyComment from "./ModifyComment";
import vAdminformat from '../../adminFormat';
import QRUpdateJobs from "./QRJobUpdate";
import STLViewer from "../Canvas/STLViewer";
import ColorBox from "../ColorBox";
import QRCode from "react-qr-code";
import { useReactToPrint } from 'react-to-print';

import SimpleSTLViewerToImage from "../Canvas/SimpleStlViewsImage";

import downloadJobPDF from "./DownloadJob";
import Swal from "sweetalert2";


const server_backend = config.API_URL;
const server_frontend = config.FrondEndURL;

const QRJobViews2 = ({ onRenderComplete, qr, trs }) => {

    const [Job, setJob] = useState([]);
    const [trackingView, setTrackingView] = useState([]);
    const [isComment, setIsComment] = useState(false);
    const [isModifiyComment, setIsModifyComment] = useState(false);
    const [onCommentID, setOnCommentID] = useState(0);
    const [isUpdating, setIsUpdating] = useState(false);
    const [loading, setLoading] = useState(false);
    const [fileURL, setFileURL] = useState(null);
    const [statusJob, setStatusJob] = useState([]);
    const [showPrintableDiv, setShowPrintableDiv] = useState(false);
    const [currentDateTime, setCurrentDateTime] = useState('');
    const [currentComment, setCurrentComment] = useState("");
    const [currentPart, setCurrentPart] = useState([]);
    const [currentStatus, setCurrentStatus] = useState(null);
    const [currentOrderID, setCurrentOrderID] = useState(null);
    const [order, setOrder] = useState([]);
    const [searchParams] = useSearchParams();
    const dropdownRef = useRef(null);
    const [changeStatus, setChangeStatus] = useState(0);
    const [currentJbQty, setCurrentJobQty] = useState(0);
    const [OrderID, setOrderID] = useState(null);

    //Obtain the values ​​of 'Trs' and 'QR' from the URL
    //const trs = searchparams.get ('trs');
    //constqr = searchparams.get ('qr');


    useEffect(() => {
        const getCurrentOrder = async () => {
            setLoading(true)
            try {
                const response = await axios.get(`${server_backend}/orders/view?trs=${trs}&qr=${qr}`, headers);
                //const response = await axios.get(`${server_backend}/Orders/select?id=${OrderID}`, headers);
                if (response.data.RES_CODE === "00") {

                    const data = (response.data.RES_RESULT);
                    console.log({ test: data })
                    setCurrentDateTime(data.date_estimated);
                    setOrderID(data.ord_ID);
                    setCurrentComment(data.comment);
                    setCurrentPart(data.parts);
                    setCurrentStatus(data.est_ID);
                    setOrder(response.data.RES_RESULT);
                    setFileURL(`${server_backend}/${data.jobs[0].files_path_file}`);
                    setJob(data.jobs);

                }
            } catch (error) {
                console.log(error)
            } finally {
                setLoading(false)
                onRenderComplete && onRenderComplete()
            }
        }
        getCurrentOrder();
    }, []);


    useEffect(() => {
        const getStatusJob = async () => {
            try {
                const response = await axios.get(`${server_backend}/system/transactions/status/Job`, headers);
                console.log(response.data);
                if (response.data.RES_CODE === "00") {
                    setStatusJob(response.data.RES_RESULT);
                }
            } catch (error) {
                console.log(error);
            }
        }
        getStatusJob();
    }, []);

    useEffect(() => {
        //Select the element with ID "Page-Topbar"
        const topbar = document.getElementById('page-topbar');
        const page = document.getElementById('page-content');

        //Verify if the element exists and hide it
        if (topbar && page) {
            topbar.style.display = 'none'; //Hides the Topbar
            page.className = ''
        }


        return () => {
            if (topbar) {
                topbar.style.display = '';
            }
        };
    }, []);


    const getCurrentOrder = async () => {
        setLoading(true)
        try {
            const response = await axios.get(`${server_backend}/Orders/select?id=${OrderID}`, headers);
            //console.log(response.data)
            if (response.data.RES_CODE === "00") {
                const data = (response.data.RES_RESULT)
                setCurrentDateTime(data.date_estimated);
                setCurrentComment(data.comment);
                setCurrentPart(data.parts)
                setCurrentStatus(data.est_ID);
                setOrder(response.data.RES_RESULT);
                setFileURL(`${server_backend}/${data.jobs[0].files_path_file}`);
                setJob(data.jobs);

            }
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false)
            onRenderComplete && onRenderComplete()
        }
    }

    /*  useEffect(() => {
          const getTrackingData = async () => {
              try {
                  const response = await axios.get(`${server_backend}/Jobs/tracking/list?id=${OrderID}`, headers);
                  if (response.data.RES_CODE === "00") {
  
                      const data = (response.data.RES_RESULT);
                      setTrackingView(data)
                  }
              } catch (error) {
                  console.log(error)
              }
}
          getTrackingData();
      }, []); */



    const getTrackingData = async () => {
        try {
            const response = await axios.get(`${server_backend}/Jobs/tracking/list?id=${OrderID}`, headers);
            if (response.data.RES_CODE === "00") {
                //console.log(response.data.RES_RESULT)
                const data = (response.data.RES_RESULT);
                setTrackingView(data)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const CloseAddCommentModal = () => {
        setIsComment(false)
    }

    const showAddCommentModal = () => {
        setIsComment(true)
    }

    const showModifyCommentModal = () => {
        setIsModifyComment(true)
    }

    const CloseModifyCommentModal = () => {
        setIsModifyComment(false)
    }

    const ShowModalUpdate = () => {
        setIsUpdating(true);
    }

    const CloseModalUpdate = () => {
        setIsUpdating(false);
    }

    const currentStep = statusJob.find((status) => status.est_ID === Job.est_ID)?.est_ID || 0;
    const lastStep = Math.max(...statusJob.map((step) => step.est_ID <= currentStep ? step.est_ID : -1));

    const statusDescriptions = {
        18: "In the process of printing the production folder.",
        19: "Preparing the model for building.",
        20: "The model is being invested for molding.",
        21: "Casting process is in progress.",
        22: "Production is complete and ready for review.",
    };



    const componentRef = useRef();


    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        documentTitle: "Material Information",
        onAfterPrint: () => setShowPrintableDiv(false),

    });

    const handleClick = () => {

        setShowPrintableDiv(true);
        setTimeout(() => {
            handlePrint();
        }, 2000);

    };

    const [imageURL, setImageURL] = useState(null);

    useEffect(() => {
        const loadImage = async () => {
            try {
                const image = await SimpleSTLViewerToImage(fileURL);

                setImageURL(image);
            } catch (error) {
                console.error('Error:', error);
            }
        };

        if (fileURL) {
            loadImage();
        }
    }, [fileURL]);






    const handleUpdate = async (estID) => {

        setLoading(true);

        Swal.fire({
            icon: 'warning',
            title: 'Alert',
            text: "Are you sure you want to save this transaction?",
            showCancelButton: true,
            confirmButtonText: 'Accept',
            cancelButtonText: "Cancel"
        }).then(async (result) => {
            if (result.isConfirmed) {

                try {
                    const response = await axios.post(`${server_backend}/orders/scan_point`, {
                        id: OrderID,
                        point: estID
                    }, headers);
                    //console.log(response.data);
                    if (response.data.RES_CODE === "00") {
                        /*  Swal.fire({
                              icon: 'success',
                              title: 'Updated Successfully',
                              showConfirmButton: false,
                              timer: 2000
                          }); */

                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error updating Order',
                            showConfirmButton: false,
                            timer: 2000
                        });
                    }
                } catch (error) {
                    const responseData = error.response.data.RES_MESSAGE;
                    //console.log(error)
                    Swal.fire({
                        icon: 'error',
                        title: responseData,
                        showConfirmButton: false,
                        timer: 3000
                    });
                } finally {
                    getCurrentOrder();
                    setLoading(false);
                }
            }
        }
        )
    };

    const sendToXero = async (estID) => {

        setLoading(true);

        Swal.fire({
            icon: 'warning',
            title: 'Alert',
            text: "Sure you want to send the invoice to Xero",
            showCancelButton: true,
            confirmButtonText: 'Accept',
            cancelButtonText: "Cancel"
        }).then(async (result) => {
            if (result.isConfirmed) {

                /*  try {
                      const response = await axios.post(`${server_backend}/Orders/update`, {
                          ...order,
                          id: OrderID,
                          est_id: estID
                      }, headers);
                      //console.log(response.data);
                      if (response.data.RES_CODE === "00") {
                          Swal.fire({
                              icon: 'success',
title: 'Updated Successfully',
                              showConfirmButton: false,
                              timer: 2000
                          });
  
                      } else {
                          Swal.fire({
                              icon: 'error',
                              title: 'Error updating Order',
                              showConfirmButton: false,
                              timer: 2000
});
                      }
                  } catch (error) {
                      const responseData = error.response.data.RES_MESSAGE;
                      //console.log(error)
                      Swal.fire({
                          icon: 'error',
                          title: responseData,
                          showConfirmButton: false,
                          timer: 3000
                      });
                  } */
            }
        }
        )
    };


    const changePriority = async (priority) => {

        if (priority === order.priority) {
            return;
        }

        try {

            const response = await axios.post(`${server_backend}/Orders/priority`, {
                id: OrderID,
                priority: priority
            }, headers);
            //console.log(response.data);
            if (response.data.RES_CODE === "00") {
                /* Swal.fire({
                     icon: 'success',
                     title: 'Updated Successfully',
                     showConfirmButton: false,
                     timer: 2000
                 }); */

            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Error updating Order',
                    showConfirmButton: false,
                    timer: 2000
                });
            }
        } catch (error) {
            const responseData = error.response.data.RES_MESSAGE;
            //console.log(error)
            Swal.fire({
                icon: 'error',
                title: responseData,
                showConfirmButton: false,
                timer: 3000
            });
        } finally {
            getCurrentOrder()
        }

    };

    const handleSelectQuantity = async (job, quantity) => {
        //setCurrentJobQty(quantity);
        console.log({ jobID: job.ordj_ID, quantity: quantity, confirm: job.sp1_pass, point: order.point })

        try {

            const response = await axios.post(`${server_backend}/orders/jobs/point`, {
                id: job.ordj_ID,
                ord_id: OrderID,
                point: order.point,
                qty: quantity,
                confirm: order.point === 1 ? job.sp1_pass : (order.point === 2 ? job.sp2_pass : (order.point === 3 ? job.sp3_pass : (order.point === 4 ? job.sp4_pass : 0))),
            }, headers);

            if (response.data.RES_CODE === "00") {
                /*  Swal.fire({
                      icon: 'success',
                      title: 'Updated Successfully',
                      showConfirmButton: false,
                      timer: 2000
                  }); */

            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Error updating Order',
                    showConfirmButton: false,
                    timer: 2000
                });
            }
        } catch (error) {
            const responseData = error.response.data.RES_MESSAGE;
            //console.log(error)
            Swal.fire({
                icon: 'error',
                title: responseData,
                showConfirmButton: false,
                timer: 3000
            });
        } finally {
            getCurrentOrder()
        }
        //Close the dropdown manually1
        if (dropdownRef.current) {
            dropdownRef.current.classList.remove('show');
            dropdownRef.current.previousSibling.classList.remove('show');
        }
    };

    const handleChangePass = async (job, confirm) => {

        try {

            console.log({ jobID: job.ordj_ID, order: OrderID, point: order.point, qty: order.point === 1 ? job.sp1_qty : (order.point === 2 ? job.sp2_qty : (order.point === 3 ? job.sp3_qty : (order.point === 4 ? job.sp4_qty : 0))), confirm: confirm });

            if (order.point === 1) {
                if (job.sp1_pass === confirm) {
                    return;
                }
            } else if (order.point === 2) {
                if (job.sp2_pass === confirm) {
                    return;
                }
            } else if (order.point === 3) {
                if (job.sp3_pass === confirm) {
                    return;
                }
            } else if (order.point === 4) {
                if (job.sp4_pass === confirm) {
                    return;
                }
            }

            const response = await axios.post(`${server_backend}/orders/jobs/point`, {
                id: job.ordj_ID,
                ord_id: OrderID,
                point: order.point,
                qty: order.point === 1 ? job.sp1_qty : (order.point === 2 ? job.sp2_qty : (order.point === 3 ? job.sp3_qty : (order.point === 4 ? job.sp4_qty : 0))),
                confirm: confirm
            }, headers);

            if (response.data.RES_CODE === "00") {
                /* Swal.fire({
                     icon: 'success',
                     title: 'Updated Successfully',
                     showConfirmButton: false,
                     timer: 2000
                 }); */

            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Error updating Order',
                    showConfirmButton: false,
                    timer: 2000
                });
            }
        } catch (error) {
            const responseData = error.response.data.RES_MESSAGE;
            //console.log(error)
            Swal.fire({
                icon: 'error',
                title: responseData,
                showConfirmButton: false,
                timer: 3000
            });
        } finally {
            getCurrentOrder()
        }
    }

    const createInvoiceXero = async () => {

        try {

            //We initialize the object of the invoice
            const invoiceData = {
                type: "ACCREC",
                contact: {
                    contactID: "fe86b2ae-5c58-49b7-a5c6-fa7c8b8130c3", //Customer Id in Xero
                    name: order.customer_name //customer name
                },
                date: new Date().toISOString(), //Current date
                dueDate: new Date(new Date().setDate(new Date().getDate() + 10)).toISOString(), //10 -day expiration date
                dateString: new Date().toISOString(),
                dueDateString: new Date(new Date().setDate(new Date().getDate() + 10)).toISOString(),
                lineAmountTypes: "Exclusive", //prices exclude taxes
                lineItems: [], //List to store the items (products)
                //We add the shipping address to the left side
                shippingAddress: {
                    address: order.shipping_address || "",
                    city: order.shipping_city || "",
                    country: order.shipping_country || "",
                    zipcode: order.shipping_zipcode || "",
                },
                //Data of the generic company to the right side
                companyDetails: {
                    name: "Generic Company Ltd.",
                    address: "123 Business Street",
                    city: "Business City",
                    country: "Business Country",
                    zipcode: "12345",
                    phone: "+44 1234 567890",
                    email: "info@genericcompany.com"
                },
            };

            //Variables for total calculations
            let subTotal = 0;
            let totalDiscount = 0;
            let estimatedTax = 0;
            let totalAmount = 0;

            //Turn the job list (Job)
            Job.forEach((job) => {
                const itemName = job.job_number; //Item name (Job Number)
                const productDetails = `${job.file_name} - ${job.materials_name} - ${job.dimensions}`; //Product details
                const quantity = job.qty; //product quantity
                const unitPrice = parseFloat(job.price); //Unit price
                const discount = parseFloat(job.discount); //discount (in percentage)
                const itemSubtotal = quantity * unitPrice * ((100 - discount) / 100); //Subtotal with applied discount

                //Update the totals
                subTotal += itemSubtotal; //accumulate the subtotal
                totalDiscount += unitPrice * quantity * (discount / 100); //accumulate the total discount
                estimatedTax += itemSubtotal * 0.20; //Calculate the estimated tax (20%)
                totalAmount = subTotal + estimatedTax; //Calculate the total amount with taxes

                //Add the current item to the Lineitems list
                invoiceData.lineItems.push({
                    description: `${itemName}: ${productDetails}`, //Item name and product details
                    quantity: quantity.toString(), //product quantity
                    unitAmount: unitPrice.toFixed(2), //Unitary price with 2 decimals
                    accountCode: "200", //Account code (Xero specific)
                    discountRate: discount.toString(), //discount percentage
                });
            });

            //Add the total calculated to the invoice
            invoiceData.subTotal = subTotal.toFixed(2); //Subtotal with 2 decimals
            invoiceData.estimatedTax = estimatedTax.toFixed(2); //estimated tax with 2 decimals
            invoiceData.totalDiscount = totalDiscount.toFixed(2); //Total discount with 2 decimals
            invoiceData.totalAmount = totalAmount.toFixed(2); //Total amount with 2 decimals

            //URL of your node.js server
            const url = 'http://192.168.43.43:5000/api/xero/invoice'; //Change according to the address of your server

            //Section of the post request to your server
            await axios.post(url, { tenantId: "1c109485-b607-4cfa-a06f-40fb6784baf3", invoiceData });
            alert("Invoice sent successfully");

        } catch (error) {
            alert("Error generating invoice:", error.message);
        }
    };


    return (
        <div className="page-content" id="page-content">
            <div className="container-fluid">

                {/*start page title */}
                {isUpdating ? (
                    <QRUpdateJobs CloseViewJob={CloseModalUpdate} JobID={OrderID} getCurrentJob={getCurrentOrder} />
                ) : (
                    <div>
                        <div className="row justify-content-center">
                            <div className="col-12 card">
                                <div className="card-header">
                                    <div className="d-flex justify-content-between align-items-center mt-3 p-2">


                                        <div className="text-center flex-grow-1">
                                            <span className="fw-bold">Order Ref: <Link>{OrderID}</Link></span>
                                        </div>


                                    </div>

                                </div>
                                <div className="row">
                                    <div className="col-lg-8 col-md-12">
                                        <div className="row">
                                            <div className="col-lg-6 col-md-12">
                                                <div>
                                                    <div className="card card-animate">
                                                        <div className="card-body">
                                                            <div className="d-flex justify-content-between">
                                                                <div>
                                                                    <p className="fw-medium mb-0">{order.fullname}</p>

                                                                    <p className="mb-0 text-muted">First Colective</p>
                                                                    <p className="mb-0 text-muted">{vAdminformat.FormatDate(order.date_created)}</p>
                                                                </div>
                                                                <div>
                                                                    <div className="avatar-sm flex-shrink-0">
                                                                        <span
                                                                            data-bs-toggle="dropdown"
                                                                            aria-haspopup="true"
                                                                            aria-expanded="false"
                                                                            className={`avatar-title ${order.priority === 1 ? "bg-success" : (order.priority === 2 ? "bg-warning" : (order.priority === 3 ? "bg-danger opacity-50" : "bg-danger"))} rounded-circle fs-2`}
                                                                            role="button"
                                                                        >
                                                                            <i data-feather="users" className="text-light"></i>
                                                                            {order.status_common}
                                                                        </span>
                                                                        <div className="dropdown-menu p-2 shadow rounded border-0">
                                                                            <button
                                                                                className="dropdown-item bg-success text-white mb-2 rounded-lg py-2  px-3 text-center"
                                                                                style={{ transition: "all 0.3s ease", borderRadius: "10px" }}
                                                                                type="button"
                                                                                onClick={() => changePriority(1)}>
                                                                                Normal
                                                                            </button>
                                                                            <button
                                                                                className="dropdown-item bg-warning text-white mb-2 rounded-lg py-2 px-3 text-center"
                                                                                type="button"
                                                                                style={{ transition: "all 0.3s ease", borderRadius: "10px" }}
                                                                                onClick={() => changePriority(2)}>
                                                                                Important
                                                                            </button>
                                                                            <button

                                                                                className="dropdown-item bg-danger opacity-75 text-white mb-2 rounded-lg py-2 px-3 text-center"
                                                                                type="button"
                                                                                style={{ transition: "all 0.3s ease", borderRadius: "10px" }}

                                                                                onClick={() => changePriority(3)}>
                                                                                Moderate
                                                                            </button>
                                                                            <button
                                                                                className="dropdown-item bg-danger text-white rounded-lg py-2 px-3 text-center"
                                                                                type="button"
                                                                                style={{ transition: "all 0.3s ease", borderRadius: "10px" }} onClick={() => changePriority(4)}>
                                                                                Urgent
                                                                            </button>
                                                                        </div>

                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-6">
                                                                <div style={{ height: "200px", width: "100%" }} className="p-2">
                                                                    {/*STL Viewer */}
                                                                    <div
                                                                        className="col-12"
                                                                        style={{ minHeight: "115px",  border: '1px solid #dcdcdc' }}
                                                                    >
                                                                        <STLViewer url={fileURL} currentColor={Job.materials_color} mystl={true} />
                                                                    </div>


                                                                </div>
                                                            </div>
                                                            <div className="col-6">
                                                                <div className="mt-5">
                                                                    {order.point !== 1 && (
                                                                        <button className="btn btn-warning d-flex align-items-center" onClick={() => {
                                                                            if (order.point === 4) {
                                                                                handleUpdate(3)
                                                                            }
                                                                            else if (order.point === 3) {
                                                                                handleUpdate(2)
                                                                            } else if (order.point === 2) {
                                                                                handleUpdate(1)
                                                                            }
                                                                            /* else if (order.point === 4) {
                                                                                handleUpdate(1)
                                                                            }  */

                                                                        }}>
                                                                            <i className="ri-arrow-go-back-line me-2"></i>
                                                                            Send Back
                                                                        </button>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-lg-6 col-md-12">
                                                <center>
                                                    <h6 className="text-muted p-2">
                                                        {order.point === 1
                                                            ? "Correct number of waxes delivered?"
                                                            : (order.point === 2
                                                                ? "All items successfully built onto their correct trees?"
                                                                : (order.point === 3
                                                                    ? "All items successfully completed?"
                                                                    : (order.point === 4
                                                                        ? "Ready to finalize Production Sheet and weight?"
                                                                        : "")))}
                                                    </h6>
                                                </center>
                                                <div className="card" style={{ height: "30vh", maxHeight: "30vh", overflowY: "auto" }}>
                                                    <div className="mt-3">
                                                        <div className="table-responsive">
                                                            <table className="table table-borderless align-middle table-nowrap mb-0 table-sm" style={{ lineHeight: '1.9', padding: '0.4rem', height: "30vh", maxHeight: "30vh" }}>

                                                                <tbody>
                                                                    {Job.map((job) => (
                                                                        <tr key={job.id}>
                                                                            <td className="font-weight-bold">
                                                                                <h6>{job.file_name}</h6>
                                                                            </td>
                                                                            <td className="font-weight-bold">
                                                                                <h6>{job.qty}</h6>
                                                                            </td>
                                                                            <td className="font-weight-bold">
                                                                                <div className="dropdown">
                                                                                    <button
                                                                                        className="btn btn-light dropdown-toggle"
                                                                                        type="button"
                                                                                        id={`dropdownMenuButton-${order.point === 1 ? job.sp1_qty : (order.point === 2 ? job.sp2_qty : (order.point === 3 ? job.sp3_qty : (order.point === 4 ? job.sp4_qty : "")))}`}
                                                                                        data-bs-toggle="dropdown"
                                                                                        aria-expanded="false"
                                                                                    >
                                                                                        {order.point === 1 ? job.sp1_qty : (order.point === 2 ? job.sp2_qty : (order.point === 3 ? job.sp3_qty : (order.point === 4 ? job.sp4_qty : "")))}
                                                                                    </button>
                                                                                    <ul className="dropdown-menu" aria-labelledby={`dropdownMenuButton-${order.point === 1 ? job.sp1_qty : (order.point === 2 ? job.sp2_qty : (order.point === 3 ? job.sp3_qty : (order.point === 4 ? job.sp4_qty : "")))}`}>
                                                                                        {Array.from({ length: job.qty + 1 }, (_, i) => (
                                                                                            <li key={i}>
                                                                                                <button className="dropdown-item" onClick={() => handleSelectQuantity(job, i)}>
                                                                                                    {i}
                                                                                                </button>
                                                                                            </li>
                                                                                        ))}
                                                                                    </ul>
                                                                                </div>
                                                                            </td>
                                                                            <td>
                                                                                <button
                                                                                    type="button"

                                                                                    className={`btn ${order.point === 1 ? (job.sp1_pass === 1 ? "btn-success" : "btn-outline-success") : (order.point === 2 ? (job.sp2_pass === 1 ? "btn-success" : "btn-outline-success") : (order.point === 3 ? (job.sp3_pass === 1 ? "btn-success" : "btn-outline-success") : (order.point === 4 ? (job.sp4_pass === 1 ? "btn-success" : "btn-outline-success") : "")))} rounded-circle btn-icon waves-effect waves-light`}
                                                                                    onClick={() => handleChangePass(job, 1)}
                                                                                >Y</button>
                                                                            </td>
                                                                            <td>
                                                                                <button type="button"

                                                                                    className={`btn ${order.point === 1 ? (job.sp1_pass === 0 ? "btn-danger" : "btn-outline-danger") : (order.point === 2 ? (job.sp2_pass === 0 ? "btn-danger" : "btn-outline-danger") : (order.point === 3 ? (job.sp3_pass === 0 ? "btn-danger" : "btn-outline-danger") : (order.point === 4 ? (job.sp4_pass === 0 ? "btn-danger" : "btn-outline-danger") : "")))} rounded-circle btn-icon waves-effect waves-light`}
                                                                                    onClick={() => handleChangePass(job, 0)}
                                                                                >N</button>
                                                                            </td>
                                                                            <td className="text-center">
                                                                                <Link onClick={ShowModalUpdate}>

                                                                                    <i className="ri-settings-5-fill text-black" style={{ fontSize: '25px', verticalAlign: 'middle' }}></i>
                                                                                </Link>
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        </div>

                                                    </div>
                                                </div>
                                                <center>
                                                    <p className="fw-medium mb-0">Reprint Qty: {order.print}</p>
                                                </center>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-12 mt-3 mt-lg-0 p-2">
                                        <div className="col-12">

                                            <center>
                                                <div className="row w-100 mx-0">
                                                    <div className="col-6 px-1">
                                                        <button className="btn btn-warning w-100" style={{ padding: '1rem 0', borderRadius: '8px' }} onClick={showAddCommentModal}>
                                                            Reprint
                                                        </button>
                                                    </div>
                                                    <div className="col-6 px-1">
                                                        <button className={`btn ${order.point === 4 ? "btn-secondary" : "btn-success"}  w-100`} style={{ padding: '1rem 0', borderRadius: '8px' }} onClick={() => {

                                                            if (order.point === 1) {
                                                                handleUpdate(2)
                                                            } else if (order.point === 2) {
                                                                handleUpdate(3)
                                                            } else if (order.point === 3) {
                                                                handleUpdate(4)
                                                            } else if (order.point === 4) {
                                                                //handleUpdate(5)
                                                                createInvoiceXero()
                                                            }

                                                        }}>
                                                            {order.point === 1 ? "SP2" : (order.point === 2 ? "SP3" : (order.point === 3 ? "Confirm QC" : (order.point === 4 ? "Send to xero" : "SP3")))}
                                                        </button>
                                                    </div>
                                                    {/*  <div className="p-5 mt-5">
                                                        <button className="btn btn-secondary" onClick={() => {
                                                            createInvoiceXero()
                                                        }}>Send to xero</button>
                                                    </div> */}

                                                </div>
                                            </center>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                )}


                {/*end row*/}
                {isComment && (
                    <AddComment OrderID={OrderID} onClose={CloseAddCommentModal} getCurrentOrder={getCurrentOrder} />
                )}
                {isModifiyComment && (
                    <ModifyComment OrderID={OrderID} onCommentID={onCommentID} onClose={CloseModifyCommentModal} getJobs={getTrackingData} />
                )}

                <div>

                    {showPrintableDiv && (
                        <div ref={componentRef} id="printable-area" className="container mt-4 p-4" style={{ width: '500px', padding: '20px' }}>
                            <div className="row">
                                <div className="col-12 mb-4">
                                    <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '20px' }}>
                                        <tbody>
                                            <tr>
                                                <td style={{ padding: '4px 8px' }}><strong>Name:</strong></td>
                                                <td style={{ padding: '4px 8px' }}>{Job.fullname}</td>
                                            </tr>
                                            <tr>
                                                <td style={{ padding: '4px 8px' }}><strong>Job Number:</strong></td>
                                                <td style={{ padding: '4px 8px' }}>{Job.job_number}</td>
                                            </tr>
                                            <tr>
                                                <td style={{ padding: '4px 8px' }}><strong>Date:</strong></td>
                                                <td style={{ padding: '4px 8px' }}>{vAdminformat.FormatDate(Job.date_created)}</td>
                                            </tr>
                                            <tr>
                                                <td style={{ padding: '4px 8px' }}><strong>Description:</strong></td>
                                                <td style={{ padding: '4px 8px' }}>{"define"}</td>
                                            </tr>
                                            <tr>
                                                <td style={{ padding: '4px 8px' }}><strong>Parts:</strong></td>
                                                <td style={{ padding: '4px 8px' }}>{Job.parts}</td>
                                            </tr>
                                            <tr>
                                                <td style={{ padding: '4px 8px' }}><strong>Alloy:</strong></td>
                                                <td style={{ padding: '4px 8px' }}>{Job.materials_name}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <div className="col-12">
                                    <div className="row">
                                        <div className="col-6">
                                            <div className="text-center">
                                                {imageURL ? (
                                                    <img src={imageURL} alt="STL Image" style={{ width: '100%', height: '16vh', minWidth: '16vh', border: '1px solid #ccc' }} />
                                                ) : (
                                                    <p>Loading Image...</p>
                                                )}
                                            </div>
                                        </div>
                                        <div className="col-6" style={{ paddingLeft: '10px' }}>
                                            <div className="row">
                                                <div className="col-6 text-center">
                                                    {Job?.barcode && (
                                                        <QRCode
                                                            size={100}
                                                            value={Job.barcode}
                                                            style={{ marginBottom: '10px' }}
                                                        />
                                                    )}
                                                </div>
                                                <div className="col-6 text-center">
                                                    <h6 style={{ fontSize: '12px', marginTop: '40px' }}>Quick scan group</h6>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-6 text-center">
                                                    {Job?.barcode && (
                                                        <QRCode
                                                            size={100}
                                                            value={Job.barcode}
                                                        />
                                                    )}
                                                </div>
                                                <div className="col-6 text-center">
                                                    <h6 style={{ fontSize: '12px', marginTop: '40px' }}>Single back to Print folder ONLY</h6>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                </div>
            </div>
        </div>

    )
}


export default QRJobViews2;